module.exports = __webpack_public_path__ + "static/img/21.c3ae17f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/21.png
// module id = rKnG
// module chunks = 1